export const baseUrl = process.env.MIX_APP_URL
